import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchPrintPackage = createAction(ACTION.FETCH_PRINT_PACKAGE.REQUEST, params => params);
